'use client';

import React from 'react';

/**
 * ReferralSkeleton
 * Provides a loading placeholder for the referral dashboard.
 */
export const ReferralSkeleton: React.FC = () => {
  return (
    <div className="mx-auto max-w-6xl animate-pulse space-y-8 px-2 pb-20 pt-12">
      <div className="flex flex-col gap-6">
        {/* Header Placeholder */}
        <div className="h-40 rounded-2xl bg-surface-secondary" />
        {/* Stats Grid Placeholder */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="h-32 rounded-2xl bg-surface-secondary" />
          <div className="h-32 rounded-2xl bg-surface-secondary" />
          <div className="h-32 rounded-2xl bg-surface-secondary" />
        </div>
        {/* Referral History Placeholder */}
        <div className="h-64 rounded-2xl bg-surface-secondary" />
      </div>
    </div>
  );
};

export default ReferralSkeleton;
